import { render, staticRenderFns } from "./ExploreKeywords.vue?vue&type=template&id=04d5938c&scoped=true"
import script from "./ExploreKeywords.vue?vue&type=script&lang=js"
export * from "./ExploreKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5938c",
  null
  
)

export default component.exports